import { ResolveFn, Router } from '@angular/router';
import { ButtonType } from '@pxl/models/common';
import { AppRoutingRouteNames } from '@pxl/route-names';
import { RESOURCES } from '@pxl/shared/translation';
import { inject } from '@angular/core';

import { GeneralErrorData } from '../models/general-error.models';

export const unauthorizedErrorResolver: ResolveFn<GeneralErrorData> = () => {
    const router = inject(Router);
    const resourceKeys = {
        login: RESOURCES.petsxl.ui.page_not_found.actions.login,
        ...RESOURCES.petsxl.ui.unauthorized,
    };
    return {
        title: resourceKeys.headline,
        message: resourceKeys.message,
        buttons: [
            {
                label: resourceKeys.login,
                type: ButtonType.primary,
                action: () => router.navigate([AppRoutingRouteNames.SignIn]),
            },
        ],
        pageHeaderIllustration: 'error-message',
    };
};
